
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StarIcon from '@material-ui/icons/Star';
import { makeStyles } from '@material-ui/core/styles';

import Logo from '@/components/Logo';

const useStyles = makeStyles(() => ({
  container: {
    marginBottom: 16,
  },
  star: {
    color: '#F2D750',
  }
}));

function Star({ player, team, star }) {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid container item justify="center" xs={12}>
        {Array(star).fill(
          <Grid item>
            <StarIcon className={classes.star} fontSize="large" />
          </Grid>
        )}
      </Grid>
      <Grid container item alignItems="center" justify="center" xs={12}>
        <Grid item>
          <Logo id={team.id} />
        </Grid>
        <Grid item>
          <Typography>{player.name}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Star;
